/** @format */

export const ProductInfoSummaryMod = ({
  imgAlt,
  imgSrc,
  subtitle,
  title,
  desc,
}) => {
  return (
    <div id="product-info-summary" class="c-product-info-summary">
      <span class="c-product-info-summary__img">
        <img src={imgSrc} alt={imgAlt} />
      </span>
      <span class="c-product-info-summary__heading">
        <span class="c-product-info-summary__title">{title}</span>
        <span className="c-product-info-summary__description">{desc}</span>
        <span class="c-product-info-summary__subtitle">{subtitle}</span>
      </span>
    </div>
  );
};
